<template>
  <BaseMultiSelectSearch
    ref="multiSelectSearchRef"
    :suggestions="suggestions"
    :initial-loading="initialLoading"
    :loading="loading"
    :existing-selections="existingSelections"
    allow-add-custom
    :empty-selections-label="$t('page.business-intelligence.normalized-names.empty-selection')"
    :empty-suggestions-label="$t('page.business-intelligence.normalized-names.empty')"
    :description-label="$t('page.business-intelligence.normalized-names.description')"
    @updated-selected-names="(values) => $emit('updated-selected-names', values)"
    @on-search="(query) => $emit('on-search', query)"
    @all-names-selected="$emit('all-names-selected')"
  />
</template>

<script>
import BaseMultiSelectSearch from '@/components/base/BaseMultiSelectSearch.vue';

export default {
  name: 'business-intelligence-name-suggestion',
  components: {
    BaseMultiSelectSearch,
  },
  props: {
    suggestions: {
      type: Array,
      required: true,
      default: () => [],
    },
    existingSelections: {
      type: Array,
      required: false,
      default: () => [],
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    initialLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    reset() {
      this.$refs.multiSelectSearchRef.reset();
    },
  },
};
</script>

<style lang="scss"></style>
